export default "__VITE_ASSET__CE_7ak8C__"